/**
 * 处理数字精度
 * @param {number} number 要处理的数字
 * @param {number} precision 保留几位小数
 * @returns {number} 处理后的数字
 */
export function formatNumber(number, precision = 2) {
  return Number(Math.round(number + 'e' + precision) + 'e-' + precision);
} 

/**
 * 处理数字精度
 * @param {number} number 要处理的数字
 * @returns {number} 处理后的整数
 */
export function formatNumberInt(number) {
  return Math.floor(Number(number));
}

// 加法计算
export function accAdd (arg1, arg2) {
    var baseNum, baseNum1, baseNum2
    try {
      baseNum1 = arg1.toString().split('.')[1].length
    } catch (e) {
      baseNum1 = 0
    }
    try {
      baseNum2 = arg2.toString().split('.')[1].length
    } catch (e) {
      baseNum2 = 0
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
    return (arg1 * baseNum + arg2 * baseNum) / baseNum
  }